import {
  FieldEntriesSourceParameter,
  ReferenceProperty,
} from '@osos/shared/api';
import {
  CustomValidationsPresenterModel,
  FieldOptionsModel,
  InternalEntityPresenterModel,
  LocalizedValueModel,
} from '..';
import { DataTypeEnum, VirtualFieldTypeEnum } from '../enums/data-type.enum';

export interface ReferenceSource {
  entity: string;
  entriesSource?: null | string;
  entriesSourceParameters?: Array<FieldEntriesSourceParameter>;
  entriesSourceDependencies?: Array<string>;
  cascadeEnabled?: boolean;
  relatedTo?: null | string;
  relation?: null | string;
}

export class FieldPresenterModel {
  id?: string; // temporary field
  normalizedName?: string;
  name?: LocalizedValueModel;
  description?: LocalizedValueModel;
  dataType: DataTypeEnum;
  options: FieldOptionsModel;
  /** @deprecated: Legacy Support only */
  source?: string;
  sources?: ReferenceSource[];
  sourceOptions: FieldSourceOptionsPresenterModel;
  dataCollection?: string;
  block?: { internalEntity: InternalEntityPresenterModel };
  renderOptions: {
    editComponent: { component: string; options: any };
    viewComponent: { component: string; options: any };
  };
  validations: FieldValidationModel;
  valueValidators?: ReferenceProperty[];
  specificationVersion?: number;
  requirements?: StepRequirementsModel[];
  locked?: { enabled: boolean; expression?: string };
  customValidations?: CustomValidationsPresenterModel[];
  /**
   * @description
   * This property will be computed in the entity parser service
   * It will have the blockNormalizedName.fieldNormalizedName
   */
  _normalizedName?: string;
  /**
   * @TODO
   * Replace the useage of this property,And use the _normalizedName inested
   */
  compoundNormalizedName?: string;
  // This object will contains all the vars that control the validation via specific context
  /**
   * @TODO
   * Change validaitonContext to _validationContext
   */
  validationContext?: {
    invalidExpression: boolean | null;
    invalidTypeExpression: boolean | null;
  };

  virtualField?: VirtualFieldModel;
  isImplicit?: boolean;
  mapping?: DataEntityFieldMappingPresenterModel;
}

export class FieldSourceOptionsPresenterModel {
  denyCircularRelation?: boolean;
  display?: FieldSourceOptionsDisplayModel;
  /** @deprecated: Legacy Support only */
  entriesSource: null | string;
  /** @deprecated: Legacy Support only */
  cascadeEnabled?: boolean;
  /** @deprecated: Legacy Support only */
  relatedTo?: null | string;
  /** @deprecated: Legacy Support only */
  relation?: null | string;
  /** @deprecated: Legacy Support only */
  entriesSourceParameters?: Array<FieldEntriesSourceParameter>;
  /** @deprecated: Legacy Support only */
  entriesSourceDependencies?: Array<string>;
}

export enum LocalizedStringValidationMode {
  AtLeastOne = 0,
  AllLanguages = 1,
  Custom = 2,
}

export interface LocalizedInputComponentOptions {
  mode: LocalizedStringValidationMode;
  requiredLanguages?: string[];
}

export class FieldValidationModel {
  max?: ValidationRuleModel<any>;
  min?: ValidationRuleModel<any>;
  required?: RequiredValidationRuleModel;
  regex?: RegexValidationRuleModel;
  extensions?: ExtensionsValidationRule;
  localizedValidation?: LocalizedInputComponentOptions;
}

export class RequiredValidationRuleModel {
  enabled: boolean;
  expression?: string;
}

export class ExtensionsValidationRule {
  enabled: boolean;
  value?: string;
}

export class ValidationRuleModel<T> {
  enabled: boolean;
  value?: T;
  valueSourceType?: TokenSourceType;
  expression?: any;
}
export enum TokenSourceType {
  Fixed = 0,
  Field = 1,
  Expression = 2,
  Pointer = 3,
}

export enum FieldSourceParameterValueTypeEnum {
  Expression = 2,
}

export type RegexValidationRuleModel = ValidationRuleModel<string> & {
  flags: string;
};

export interface FieldSeedModel {
  normalizedName?: string;
  dataType?: DataTypeEnum;
  name?: LocalizedValueModel;
  description?: LocalizedValueModel;
  validations?: FieldValidationModel;
  renderOptions?: {
    editComponent?: string;
    viewComponent?: string;
  };
  options?: {
    readonly?: boolean;
  };
}

export class StepRequirementsModel {
  steps: { [key: string]: any };
  workflowId: string;
}

export class VirtualFieldModel {
  enabled?: boolean;
  type?: VirtualFieldTypeEnum;
  expression?: string | null;
}
export type LiteFieldPresenterModel = Pick<
  FieldPresenterModel,
  'id' | 'name' | 'normalizedName' | 'specificationVersion'
>;

export class FieldSourceOptionsDisplayModel {
  /**
   * The display for the reference component. By default, it is SelectList.
   *     The SelectDetails and DetailsSearch are only available with Reference on NonADT entities
   */
  displayFormat?: DisplayFormatEnum;
}

export enum DisplayFormatEnum {
  FlatList = 0,
  TreeList = 1,
}

export enum MappedFieldUpdateModeEnum {
  Local = 0,
  Never = 1,
  ParentOnly = 2,
  TwoWay = 3,
}

export enum MappedFieldSearchModeEnum {
  None = 0,
  Full = 1,
  StartsWith = 2,
  Partial = 3,
}
export type DataEntityFieldMappingPresenterModel = {
  enabled: boolean;
  referenceFieldId: string;
  sourceFieldId: string;
  updateMode: MappedFieldUpdateModeEnum;
  searchModeEnabled?: boolean;
  searchMode?: MappedFieldSearchModeEnum;
};
export interface FieldMappingSearchModel {
  matchType: MappedFieldSearchModeEnum;
  value: any | any[];
}
export type ApplicationReferenceOptionsPresenterModel = {
  scope: ApplicationReferenceScopeLevel;
};
export enum ApplicationReferenceScopeLevel {
  SystemLevel = 0,
  CurrentUserLevel = 1,
}

export function getFieldSource(field: FieldPresenterModel) {
  return field.sources?.length === 1 ? field.sources[0].entity : null;
}
